export default "__VITE_ASSET__DmLy0Nfz__"